import { css } from '@emotion/core';
// font-family is derived from http://neos21.hatenablog.com/entry/2017/11/12/080000#%E7%AD%89%E5%B9%85-%E3%83%A2%E3%83%8E%E3%82%B9%E3%83%9A%E3%83%BC%E3%82%B9-%E3%81%AE%E3%83%95%E3%82%A9%E3%83%B3%E3%83%88%E6%8C%87%E5%AE%9A
export const editable = css `
  font-family: MeiryoKe_Gothic, 'Ricty Diminished', 'Osaka－等幅', 'Osaka-等幅',
    Osaka-mono, 'ＭＳ ゴシック', 'MS Gothic', 'Courier New', Courier, Monaco,
    Menlo, Consolas, 'Lucida Console', monospace;
  line-height: 1.4em;

  counter-reset: line-number 0;
`;
//# sourceMappingURL=styles.js.map